import { gql } from '@apollo/client';

const getLetterTemplate = gql`
  query getLetterTemplate($id: Int!) {
    getLetterTemplate(id: $id) {
      id
      name
      description
      content
      variables_used
      created_by
      created_at
      updated_at
      is_active
    }
  }
`;

export default getLetterTemplate;
